import { render, staticRenderFns } from "./DcApprovalProcessAwait.vue?vue&type=template&id=7b9720f2&scoped=true"
import script from "./DcApprovalProcessAwait.vue?vue&type=script&lang=js"
export * from "./DcApprovalProcessAwait.vue?vue&type=script&lang=js"
import style0 from "./DcApprovalProcessAwait.vue?vue&type=style&index=0&id=7b9720f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9720f2",
  null
  
)

export default component.exports